import React, { Fragment, useEffect, useMemo, useState } from "react";
import emptyState from "../Assets/Images/emptyState.png";
import { timeformatter } from "../utils/dateformatter";
import Loader from "./Utils/Loader";
import { getInvestmentTimeline } from "../store/actions/investment/getInvestmentTimeline";
import { useDispatch } from "react-redux";

const InvestmentTimelineSummary = ({ state, type }) => {
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (type == "REAL-ESTATE") {
      dispatch(
        getInvestmentTimeline({
          payload: {
            cycle_id: state?.investment?.id || state?.cycle_details?.id,
            investment_type: type === "REAL-ESTATE" ? "property" : "business",
          },
          // Investment ID used for RealEstate
          investmentId:
            type === "REAL-ESTATE"
              ? state?.investment?.property?.id ||
                state?.investment?.id ||
                state?.campaign?.id ||
                state?.investment_product_id
              : state?.investment?.property?.id ||
                state?.campaign?.id ||
                state?.investment_product_id,
          cb: (data) => {
            setData(data);
            setLoading(false);
          },
          failed: () => {
            setLoading(false);
          },
        })
      );
      // setLoading(false);
    } else {
      dispatch(
        getInvestmentTimeline({
          payload: {
            cycle_id: state?.investment?.id || state?.cycle_details?.id,
            investment_type: type === "REAL-ESTATE" ? "property" : "business",
          },
          // Campaign ID/Investment ID used
          investmentId:
            state?.campaign?.id ||
            state?.investment?.investment_id ||
            state?.investment?.campaignID ||
            state?.investment?.id ||
            state?.investment_product_id,
          cb: (data) => {
            setData(data);
            setLoading(false);
          },
          failed: () => {
            setLoading(false);
          },
        })
      );
    }
  }, []);

  const step1 = useMemo(
    () =>
      data.find((item) => item?.status == 1)?.date ||
      state?.cycle_details?.created_at ||
      state?.investment?.created_at,
    [data]
  );
  const step2 = useMemo(
    () => data.find((item) => item?.status == 2)?.date,
    [data]
  );
  const step3 = useMemo(
    () => data.find((item) => item?.status == 3)?.date,
    [data]
  );
  const step4 = useMemo(
    () => data.find((item) => item?.status == 4)?.date,
    [data]
  );
  const step5 = useMemo(
    () => data.find((item) => item?.status == 5)?.date,
    [data]
  );

  return (
    <div className=" md:p-5  w-full ">
      <div className=" text-[16px] font-[500] mb-6 text-[#131e3d] ">
        {" "}
        Investment Timeline{" "}
      </div>

      <div className="  flex  mt-[10px] p-[30px] gap-[12px] w-full max-w-[696px] min-h-[475px] max-h-[482px] overflow-y-auto show-scroll-bar rounded-[12px] border-[1px] border-[#f2f2f2]">
        {loading ? (
          <div className="flex-1  flex justify-center items-center">
            <Loader />
          </div>
        ) : type === "REAL-ESTATE" || true ? (
          data?.length > 0 ? (
            <div className="flex  items-start gap-[12px] ">
              <div className="flex flex-col gap-[8px] items-center mt-[10px]">
                {data?.map((timeline, index) => {
                  return (
                    <Fragment key={index}>
                      <div className="flex flex-col items-center">
                        {timeline?.status?.toLocaleLowerCase() !== "pending" ? (
                          <div className="w-[14px] h-[14px] bg-white border-[1px] rounded-full border-[#16a267] flex justify-center items-center">
                            <div className="w-[7px] h-[7px] bg-[#16a267] rounded-full"></div>
                          </div>
                        ) : (
                          <div className="w-[14px] h-[14px] bg-white border-[1px] rounded-full border-[#9c9c9e] flex justify-center items-center">
                            <div className="w-[7px] h-[7px] bg-transparent rounded-full"></div>
                          </div>
                        )}
                      </div>
                      {data?.length === index + 1 ? (
                        <></>
                      ) : timeline?.description ? (
                        <div className="w-[1px] border-l-[1px] border-dashed border-[#131e3d] h-[120px]"></div>
                      ) : (
                        <div className="w-[1px] border-l-[1px] border-dashed border-[#131e3d] h-[50px]"></div>
                      )}
                    </Fragment>
                  );
                })}
              </div>
              <div className="flex flex-col mt-[4px] ">
                {data?.map((timeline, index) => {
                  return (
                    <div
                      key={index}
                      className={`text-[16px] ${
                        timeline?.description ? "h-[150px]" : "h-[80px]"
                      } ${
                        timeline?.date ? "text-[#131e3d]" : "text-[#9C9C9E]"
                      } ] font-[500]`}
                    >
                      {timeline?.title}
                      {timeline?.description ? (
                        <div className="border my-2 shadow rounded-[8px] py-2 px-3 border-[#0000000F] bg-[#0000000A] ">
                          <h4 className="text-[12px] font-[400] text-[#000000]">
                            {timeline?.description}
                          </h4>
                        </div>
                      ) : (
                        <></>
                      )}
                      <div className="text-[14px] font-[400] text-[#9C9C9E]">
                        {timeline?.date
                          ? timeformatter(timeline?.date, "formal")
                          : "___"}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          ) : (
            <div className="w-full flex-col h-[400px] flex justify-center items-center">
              <img
                src={emptyState}
                alt=""
                className=" mb-[5px] w-[76px] h-[76px] "
              />
              <div className=" mb-[5px] p-2 text-[16px] font-[400] text-[#9C9C9E] ">
                Timeline Not Uploaded
              </div>
            </div>
          )
        ) : (
          <div className="flex  items-start gap-[12px] ">
            <div className="flex flex-col gap-[8px] items-center mt-[10px]">
              <div className="flex flex-col items-center">
                {step1 ? (
                  <div className="w-[14px] h-[14px] bg-white border-[1px] rounded-full border-[#16a267] flex justify-center items-center">
                    <div className="w-[7px] h-[7px] bg-[#16a267] rounded-full"></div>
                  </div>
                ) : (
                  <div className="w-[14px] h-[14px] bg-white border-[1px] rounded-full border-[#9c9c9e] flex justify-center items-center">
                    <div className="w-[7px] h-[7px] bg-transparent rounded-full"></div>
                  </div>
                )}
              </div>
              <div className="w-[1px] border-l-[1px] border-dashed border-[#131e3d] h-[50px]"></div>

              <div className="flex flex-col items-center">
                {step2 ? (
                  <div className="w-[14px] h-[14px] bg-white border-[1px] rounded-full border-[#16a267] flex justify-center items-center">
                    <div className="w-[7px] h-[7px] bg-[#16a267] rounded-full"></div>
                  </div>
                ) : (
                  <div className="w-[14px] h-[14px] bg-white border-[1px] rounded-full border-[#9c9c9e] flex justify-center items-center">
                    <div className="w-[7px] h-[7px] bg-transparent rounded-full"></div>
                  </div>
                )}
              </div>
              <div className="w-[1px] border-l-[1px] border-dashed border-[#131e3d] h-[50px]"></div>

              <div className="flex flex-col items-center">
                {step3 ? (
                  <div className="w-[14px] h-[14px] bg-white border-[1px] rounded-full border-[#16a267] flex justify-center items-center">
                    <div className="w-[7px] h-[7px] bg-[#16a267] rounded-full"></div>
                  </div>
                ) : (
                  <div className="w-[14px] h-[14px] bg-white border-[1px] rounded-full border-[#9c9c9e] flex justify-center items-center">
                    <div className="w-[7px] h-[7px] bg-transparent rounded-full"></div>
                  </div>
                )}
              </div>
              <div className="w-[1px] border-l-[1px] border-dashed border-[#131e3d] h-[50px]"></div>

              <div className="flex flex-col items-center">
                {step4 ? (
                  <div className="w-[14px] h-[14px] bg-white border-[1px] rounded-full border-[#16a267] flex justify-center items-center">
                    <div className="w-[7px] h-[7px] bg-[#16a267] rounded-full"></div>
                  </div>
                ) : (
                  <div className="w-[14px] h-[14px] bg-white border-[1px] rounded-full border-[#9c9c9e] flex justify-center items-center">
                    <div className="w-[7px] h-[7px] bg-transparent rounded-full"></div>
                  </div>
                )}
              </div>
              <div className="w-[1px] border-l-[1px] border-dashed border-[#131e3d] h-[50px]"></div>

              {step5 ? (
                <div className="w-[14px] h-[14px] bg-white border-[1px] rounded-full border-[#16a267] flex justify-center items-center">
                  <div className="w-[7px] h-[7px] bg-[#16a267] rounded-full"></div>
                </div>
              ) : (
                <div className="w-[14px] h-[14px] bg-white border-[1px] rounded-full border-[#9c9c9e] flex justify-center items-center">
                  <div className="w-[7px] h-[7px] bg-transparent rounded-full"></div>
                </div>
              )}
            </div>
            <div className="flex flex-col mt-[4px] ">
              <div
                className={`text-[16px] h-[80px] ${
                  step1 ? "text-[#131e3d]" : "text-[#9C9C9E]"
                } ] font-[500]`}
              >
                Campaign launched
                <div className="text-[14px] font-[400] text-[#9C9C9E]">
                  {step1 && step1 != true
                    ? timeformatter(step1, "formal")
                    : "___"}
                </div>
              </div>
              <div
                className={`text-[16px] h-[80px] ${
                  step2 ? "text-[#131e3d]" : "text-[#9C9C9E]"
                } ] font-[500]`}
              >
                Funding Completed
                <div className="text-[14px] font-[400] text-[#9C9C9E]">
                  {step2 ? timeformatter(step2, "formal") : "___"}
                </div>
              </div>

              <div
                className={`text-[16px] h-[80px] ${
                  step3 ? "text-[#131e3d]" : "text-[#9C9C9E]"
                } ] font-[500]`}
              >
                Goods Purchased
                <div className="text-[14px] font-[400] text-[#9C9C9E]">
                  {step3 ? timeformatter(step3, "formal") : "___"}
                </div>
              </div>
              <div
                className={`text-[16px] h-[80px] ${
                  step4 ? "text-[#131e3d]" : "text-[#9C9C9E]"
                } ] font-[500]`}
              >
                Goods Sold to business
                <div className="text-[14px] font-[400] text-[#9C9C9E]">
                  {step4 ? timeformatter(step4, "formal") : "___"}
                </div>
              </div>

              <div
                className={`text-[16px] h-[80px] ${
                  step5 ? "text-[#131e3d]" : "text-[#9C9C9E]"
                } ] font-[500]`}
              >
                Profit Payout Started
                <div className="text-[14px] font-[400] text-[#9C9C9E]">
                  {step5 ? timeformatter(step5, "formal") : "___"}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default InvestmentTimelineSummary;
